// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__22dGn","contained":"OpenButton_contained__2z4zW","disabled":"OpenButton_disabled__3lWPU","error":"OpenButton_error__2at5k"};